/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ContractBulkActionType = 'MASS_COPY_CONTRACTS' | 'MASS_CHANGE_CONTRACT_STATE' | 'MASS_APPENDICES' | 'MASS_CREATE_CONTRACT_DOCUMENTS' | 'MASS_CREATE_PAYMENTS' | 'MASS_END_CONTRACTS' | 'REPRICE' | 'INFLATION_INCREASE' | 'REPRICE_AND_INFLATION_INCREASE' | 'VALORIZATION' | 'REPLACE_PARCEL_VERSIONS';

export const ContractBulkActionType = {
    MASS_COPY_CONTRACTS: 'MASS_COPY_CONTRACTS' as ContractBulkActionType,
    MASS_CHANGE_CONTRACT_STATE: 'MASS_CHANGE_CONTRACT_STATE' as ContractBulkActionType,
    MASS_APPENDICES: 'MASS_APPENDICES' as ContractBulkActionType,
    MASS_CREATE_CONTRACT_DOCUMENTS: 'MASS_CREATE_CONTRACT_DOCUMENTS' as ContractBulkActionType,
    MASS_CREATE_PAYMENTS: 'MASS_CREATE_PAYMENTS' as ContractBulkActionType,
    MASS_END_CONTRACTS: 'MASS_END_CONTRACTS' as ContractBulkActionType,
    REPRICE: 'REPRICE' as ContractBulkActionType,
    INFLATION_INCREASE: 'INFLATION_INCREASE' as ContractBulkActionType,
    REPRICE_AND_INFLATION_INCREASE: 'REPRICE_AND_INFLATION_INCREASE' as ContractBulkActionType,
    VALORIZATION: 'VALORIZATION' as ContractBulkActionType,
    REPLACE_PARCEL_VERSIONS: 'REPLACE_PARCEL_VERSIONS' as ContractBulkActionType
};

